// extracted by mini-css-extract-plugin
export default {"cls1":"IGtE0xK1r2Pcw5dBc8iw","cls2":"_Rwi_sTnoLMQMpaBu5m7 IGtE0xK1r2Pcw5dBc8iw"};